class CustomReviewSwiper extends HTMLElement {
    constructor() {
        super();
        this.swiper = null;
        this.swiperContainer = this.querySelector('.swiper');
    }

    connectedCallback() {
        this.initSwiper();
    }

    initSwiper() {
        if (this.swiperContainer) {
            // const scrollbar = this.querySelector('.swiper-scrollbar');
            // const prevButton = this.querySelector('.swiper-button-prev');
            // const nextButton = this.querySelector('.swiper-button-next');
            // const navigation = {};
            // if (nextButton) {
            //     navigation.nextEl = nextButton;
            // }
            // if (prevButton) {
            //     navigation.prevEl = prevButton;
            // }
            this.swiper = new Swiper(this.swiperContainer, {
                slidesPerView: 5,
                spaceBetween: 30,
                // scrollbar: {
                //     el: scrollbar,
                // },
                // navigation: navigation,
                breakpoints: {
                    320: {
                        slidesPerView: 1.3,
                        centeredSlides: true,
                    },
                    750: {
                        centeredSlides: false,
                        slidesPerView: 3,
                    },
                    1100: {
                        centeredSlides: false,
                        slidesPerView: 4,
                    },
                    1300: {
                        centeredSlides: false,
                        slidesPerView: 5,
                    }
                }
            });
        }
    }
}

customElements.define('custom-review-swiper', CustomReviewSwiper);
